import { generatedPosts } from './posts.generated';
import type { GeneratedPost } from './postTypes';

const sortedPosts: GeneratedPost[] = [...generatedPosts].sort((a, b) =>
  b.date.localeCompare(a.date)
);

export function getAllPosts(): GeneratedPost[] {
  return sortedPosts;
}

export function getPostBySlug(slug: string): GeneratedPost | undefined {
  return sortedPosts.find((post) => post.slug === slug);
}

export function getRelatedPosts(post: GeneratedPost, limit = 3): GeneratedPost[] {
  const scored = sortedPosts
    .filter((candidate) => candidate.slug !== post.slug)
    .map((candidate) => ({
      candidate,
      score: candidate.tags.filter((tag) => post.tags.includes(tag)).length,
    }))
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((entry) => entry.candidate);
}

export function formatPostDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
